// extracted by mini-css-extract-plugin
export default {"playerWrapper":"index_playerWrapper__XMLy-"};